'use client';

import * as AccordionPrimitive from '@radix-ui/react-accordion';
import clsx from 'clsx';
import { forwardRef } from 'react';

const Accordion = AccordionPrimitive.Root;

const AccordionItem = forwardRef(
  (
    {
      className,
      ...props
    }: { className?: string; children?: React.ReactNode; value: string },
    ref: React.Ref<HTMLDivElement>,
  ) => (
    <AccordionPrimitive.Item
      ref={ref}
      className={clsx('border-b border-[#ABABAB]', className)}
      {...props}
    />
  ),
);
AccordionItem.displayName = 'AccordionItem';

const AccordionTrigger = forwardRef(
  (
    { className, headline, ...props }: { className?: string; headline: string },
    ref: React.LegacyRef<HTMLButtonElement>,
  ) => {
    return (
      <AccordionPrimitive.Header className="flex items-center">
        <AccordionPrimitive.Trigger
          ref={ref}
          className={clsx(
            'flex flex-1 items-center justify-between py-8 text-left text-[20px] font-bold leading-[30px] [&:not([data-state=open])>.close]:hidden [&[data-state=open]>.open]:hidden',
            className,
          )}
          {...props}
        >
          <div dangerouslySetInnerHTML={{ __html: headline }} />
          <svg fill="none" viewBox="0 0 12 13" className="open h-3 w-3 min-w-3">
            <path stroke="#000" d="M6 .95v6m0 6v-6m0 0h6m-6 0H0" />
          </svg>
          <svg
            fill="none"
            viewBox="0 0 12 13"
            className="close h-3 w-3 min-w-3"
          >
            <path stroke="#000" d="M12 6.95H0" />
          </svg>
        </AccordionPrimitive.Trigger>
      </AccordionPrimitive.Header>
    );
  },
);
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = forwardRef(
  (
    { className, content, ...props }: { className?: string; content: string },
    ref: React.Ref<HTMLDivElement>,
  ) => (
    <AccordionPrimitive.Content
      ref={ref}
      className="overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
      {...props}
    >
      <div
        className={clsx(
          'flex flex-col gap-y-4 pb-8 pt-0 text-[18px] leading-[30px]',
          className,
        )}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </AccordionPrimitive.Content>
  ),
);

AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger };
